<!-- 顶栏 license by http://eleadmin.com -->
<template>
  <div
    :class="['ele-admin-header', { 'ele-bg-primary': headStyle === 'primary' }]"
  >
    <!-- logo -->
    <div class="ele-admin-logo" @click="onLogoClick">
      <slot name="logo" />
      <span v-if="projectName">{{ projectName }}</span>
    </div>
    <!-- 左侧功能区 -->
    <div class="ele-admin-header-tool" v-if="showLeftTool">
      <div
        v-if="showCollapse"
        class="ele-admin-header-tool-item"
        @click="toggleCollapse"
      >
        <i :class="collapse ? 'el-icon-_unfold' : 'el-icon-_fold'"></i>
      </div>
      <div
        v-if="showRefresh"
        class="ele-admin-header-tool-item"
        @click="reloadPage"
      >
        <i class="el-icon-refresh-right"></i>
      </div>
      <!-- 自定义左侧功能 -->
      <slot name="left" />
    </div>
    <!-- 面包屑导航 -->
    <el-breadcrumb
      v-if="showBreadcrumb"
      :separator="breadcrumbSeparator"
      class="ele-admin-breadcrumb hidden-sm-and-down"
    >
      <el-breadcrumb-item
        v-for="(d, i) in levels"
        :key="i"
        :to="d.home ? '/' : null"
      >
        {{ d.title }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 自定义中间区域 -->
    <slot name="center" />
    <!-- 顶部菜单区 -->
    <el-scrollbar class="ele-admin-header-nav-wrap">
      <el-menu
        v-if="useDeep"
        mode="horizontal"
        :class="themeClass"
        :default-active="active"
        @mousewheel.native="scrollHeaderNav"
      >
        <template v-for="menu in menus">
          <ele-pro-sidebar-item
            v-if="!menu.meta.hide"
            :key="menu.path"
            :item="menu"
          />
        </template>
      </el-menu>
      <ele-pro-sidebar-menus
        v-else
        :data="menus"
        mode="horizontal"
        :default-active="active"
        :theme-class="themeClass"
        @mousewheel.native="scrollHeaderNav"
      />
    </el-scrollbar>
    <!-- 右侧功能区 -->
    <slot name="right" />
  </div>
</template>

<script>
  import EleProSidebarItem from './ele-pro-sidebar-item.vue';
  import EleProSidebarMenus from './ele-pro-sidebar-menus.vue';

  export default {
    name: 'EleProHeader',
    components: { EleProSidebarItem, EleProSidebarMenus },
    emits: ['logo-click', 'reload-page', 'toggle-collapse'],
    props: {
      // 项目名
      projectName: String,
      // 面包屑导航数据
      levels: Array,
      // 顶栏菜单数据
      menus: Array,
      // 顶栏菜单选中
      active: String,
      // 顶栏风格
      headStyle: String,
      // 是否折叠侧边栏
      collapse: Boolean,
      // 是否显示左边功能区
      showLeftTool: Boolean,
      // 是否显示折叠按钮
      showCollapse: Boolean,
      // 是否显示刷新按钮
      showRefresh: Boolean,
      // 是否显示面包屑导航
      showBreadcrumb: Boolean,
      // 面包屑导航分隔符
      breadcrumbSeparator: String,
      // 是否使用递归渲染菜单item
      useDeep: Boolean
    },
    data() {
      return {
        // 导航滚动节流
        canScroll: true
      };
    },
    computed: {
      themeClass() {
        return [
          'ele-admin-header-nav',
          this.headStyle === 'light' ? '' : 'ele-menu-dark'
        ].join(' ');
      }
    },
    methods: {
      /* 折叠展开侧栏 */
      toggleCollapse() {
        this.$emit('toggle-collapse');
      },
      /* 刷新页面 */
      reloadPage() {
        this.$emit('reload-page');
      },
      /* logo点击事件 */
      onLogoClick() {
        this.$emit('logo-click');
      },
      /* 滚动顶栏导航 */
      scrollHeaderNav(e) {
        e.stopPropagation();
        e.preventDefault();
        if (!this.canScroll) {
          return;
        }
        this.canScroll = false;
        let elem = e.currentTarget.parentNode.parentNode;
        const delta = e.wheelDelta || e.detail;
        if (delta > 0) {
          elem.scrollLeft -= 45;
        } else if (delta < 0) {
          elem.scrollLeft += 45;
        }
        setTimeout(() => {
          this.canScroll = true;
        }, 5);
      }
    }
  };
</script>
